var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"users-window"},[_c('h1',{staticClass:"page-header"},[_vm._v("Users")]),_c('div',{staticClass:"table"},[_c('users-table',{attrs:{"viewPage":'users'}})],1),_c('learner-profile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }